var map = {
	"./austin.svg": "1cdb",
	"./baku.svg": "6521",
	"./barcelona.svg": "b4da",
	"./brazil.svg": "29de",
	"./hungaroring.svg": "fa35",
	"./imola.svg": "ec08",
	"./jeddah.svg": "7b14",
	"./lusail.svg": "6668",
	"./marina-bay.svg": "60da",
	"./melbourn.svg": "95c2",
	"./mexico.svg": "7d7a",
	"./miami.svg": "9839",
	"./monaco.svg": "e2fd",
	"./montreal.svg": "3d7a",
	"./monza.svg": "03ec",
	"./paulricard.svg": "2f39",
	"./redbull.svg": "59ed",
	"./sakhir.svg": "295a",
	"./shanghai.svg": "e1f4",
	"./silverstone.svg": "bc80",
	"./sochi.svg": "d24d",
	"./spa.svg": "caf1",
	"./suzuka.svg": "ab8b",
	"./vegas.svg": "eca2",
	"./yas-marina.svg": "3328",
	"./zandvoort.svg": "47ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0e5e";